var formatNumber = function (n) {
    return new Intl.NumberFormat('en-US').format(n);
};
export default formatNumber;
//# sourceMappingURL=formatNumber.js.map